export default "__VITE_ASSET__BYls9Y5A__"